import { render } from "./text-input.vue?vue&type=template&id=4f8feb1c&scoped=true"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"

import "./text-input.vue?vue&type=style&index=0&id=4f8feb1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8feb1c"]])

export default __exports__